module.exports = __webpack_public_path__ + "media/images/stallions2-83266231.png";